import { render, staticRenderFns } from "./AddEventModal.vue?vue&type=template&id=3fcf3d12"
import script from "./AddEventModal.vue?vue&type=script&lang=js"
export * from "./AddEventModal.vue?vue&type=script&lang=js"
import style0 from "./AddEventModal.vue?vue&type=style&index=0&id=3fcf3d12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports